import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { IPatchOperation } from "../../../utils/interfaces";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";

interface IProps {
  resourceType: string;
  resourceId: string;
  path: string;
  value: any;
  op?: string;
}

/**
 * Função genérica para fazer patch de qualquer campo em um recurso FHIR
 * @param resourceType - Tipo do recurso FHIR (ex: Observation, Patient)
 * @param resourceId - ID do recurso
 * @param field - Nome do campo a ser atualizado (ex: status, note, value)
 * @param value - Novo valor para o campo
 * @param op - Operação a ser realizada (ex: replace, add, remove)
 * @param path - Caminho do campo a ser atualizado (ex: /status, /note, /value)
 */
export async function EHRPosterPatchField({
  resourceType,
  resourceId,
  path,
  value,
  op = "replace",
}: IProps) {
  const url = `${endpoints.EHRPOSTER}/${resourceType}/${resourceId}`;

  let operations: IPatchOperation[] = [];

  if (value !== undefined && value !== null)
    operations.push({
      op: op,
      path: path,
      value: value,
    });

  const data = auxiliarData.Patch({
    operations,
  });
  const headers = {
    Accept: "application/fhir+json",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/json-patch+json",
  };

  const response = await useAxios
    .patch(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`EHRPoster Patch Field: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("EHRPosterPatchField ", error);
      throw new Error();
    });
  if (response) return response;
} 